module.exports = __webpack_public_path__ + "61ac447eba5ce2dfb55d11b406d3d75f.png";